import React from 'react'
import PropTypes from 'prop-types'

import Paginator from '../Paginator'
import ItemPost from '../ItemPost'
import SideBar from '../SideBar'

const GridPosts = ({ posts, pageContext }) => {
  const { numPages } = pageContext

  return (
    <div className='padding-tb-50px'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8'>
            <div className='row'>
              {
                posts.map(({ node }, index) => <ItemPost key={index} {...node} />)
              }
            </div>
            {numPages !== 1 && <Paginator pageContext={pageContext} />}
          </div>
          <div className='col-lg-4'>
            {posts.length > 0 && <SideBar list />}
          </div>
        </div>
      </div>
    </div>
  )
}

GridPosts.propTypes = {
  type: PropTypes.string,
  posts: PropTypes.arrayOf(PropTypes.shape())

}

GridPosts.defaultProps = {
  type: '',
  posts: []
}

export default GridPosts
